export function getSrc(dom) {
  if (!dom) return ''

  const value = dom.getAttribute('data-search-gt-src') || ''
  return value
}

export function other() {}
